"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[379],{

/***/ 90379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80850);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);

 // ネクスト標準のエラーがエラーメッセージをカスタム不能だったため(statusコードのみでの制御だった)
// こちらで同じスタイルで標準エラーコンポーネントを定義。




var CustomError = function CustomError(_ref) {
  var heading = _ref.heading,
      message = _ref.message;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: "jsx-4028816683" + " " + "wrapper",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "jsx-4028816683",
      children: [heading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
        className: "jsx-4028816683" + " " + "heading",
        children: heading
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "jsx-4028816683" + " " + "msg-wrapper",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h2", {
          className: "jsx-4028816683" + " " + "msg",
          children: message
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: "4028816683",
      children: [".wrapper.jsx-4028816683{color:#000;background:#fff;font-family:-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI','Fira Sans',Avenir, 'Helvetica Neue','Lucida Grande',sans-serif;height:calc(100vh - 48px - 240px);text-align:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}", ".msg-wrapper.jsx-4028816683{display:inline-block;text-align:left;line-height:49px;height:49px;vertical-align:middle;}", ".heading.jsx-4028816683{display:inline-block;border-right:1px solid rgba(0,0,0,0.3);margin:0;margin-right:20px;padding:10px 23px 10px 0;font-size:24px;font-weight:500;vertical-align:top;}", ".msg.jsx-4028816683{font-size:14px;font-weight:normal;line-height:inherit;margin:0;padding:0;padding-top:2px;}"]
    })]
  });
};

CustomError.defaultProps = {
  heading: null
};
/* harmony default export */ __webpack_exports__["default"] = (CustomError);

/***/ })

}]);